import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultPromotionContent: PageTypeContentModule = {
  pageTypeSlug: "promotion",
  suggestedTitles: ["Special Offer", "Sale Announcement", "Limited Time Deal", "New Collection"],
  suggestedSlugs: ["special-offer", "sale", "limited-deal", "new-collection"],
  description: "Promotional content, sales, and special offers",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "Special Offer", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "Don't miss out on our exclusive promotion! For a limited time, take advantage of this special offer.",
        },
      },
      {
        type: "header",
        data: { text: "What's Included", level: 2 },
      },
      {
        type: "list",
        data: {
          style: "unordered",
          items: [
            "Premium quality products",
            "Exclusive discounts",
            "Free shipping on orders over $X",
            "Bonus gifts with purchase",
            "Extended warranty options",
          ],
        },
      },
      {
        type: "header",
        data: { text: "How to Redeem", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "Simply add your items to cart and the discount will be applied automatically at checkout. Offer valid while supplies last.",
        },
      },
      {
        type: "header",
        data: { text: "Terms & Conditions", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "This offer cannot be combined with other promotions. Discount applies to select items only. While supplies last.",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
